/**
 * KosyamLogo — SVG mark inspired by the Mòoré meaning of *Kosyam* ("ask for knowledge").
 * The mark = an open book base + rising graduation arc reaching upward, echoing the
 * gesture of asking. Fully themed via currentColor + accent.
 */
export function KosyamLogo({ size = 40, className = "", withText = false, textClass = "" }) {
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"
           aria-label="Kosyam logo" role="img">
        <rect width="48" height="48" rx="10" fill="currentColor" />
        {/* Open book base */}
        <path d="M9 32 C 14 29, 21 29, 24 32 C 27 29, 34 29, 39 32 L 39 36 C 34 33, 27 33, 24 36 C 21 33, 14 33, 9 36 Z"
              fill="#ffffff" opacity="0.95" />
        {/* Rising arc — knowledge reaching upward */}
        <path d="M14 22 Q 24 8, 34 22" stroke="#f4a261" strokeWidth="2.6" strokeLinecap="round" fill="none" />
        {/* Star / spark at apex */}
        <circle cx="24" cy="12" r="2.4" fill="#f4a261" />
        <circle cx="24" cy="12" r="0.9" fill="#ffffff" />
      </svg>
      {withText && (
        <div className={textClass || "leading-none"}>
          <div className="font-heading font-bold">Kosyam</div>
        </div>
      )}
    </div>
  );
}

export default KosyamLogo;
